export default function generateUUID(): string {
	const s: string[] = []
	const hexDigits = '0123456789abcdef'

	for (let i = 0; i < 36; i++) {
		s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
	}

	// bits 12-15 of the time_hi_and_version field to 0010
	s[14] = '4'

	// bits 6-7 of the clock_seq_hi_and_reserved to 01
	s[19] = hexDigits.substr((parseInt(s[19], 16) & 0x3) | 0x8, 1)

	// Set the UUID version and variant fields
	s[8] = s[13] = s[18] = s[23] = '-'

	const uuid = s.join('')
	return uuid
}
